export default {
  "content": "<path d=\"M7.68 9.67A.97.97 0 007 11.34l4.31 4.3c.38.39 1 .39 1.38 0l4.31-4.3a.97.97 0 00-.68-1.67H7.68z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#707070",
    "viewBox": "0 0 24 24"
  }
};